import { Link, styled } from '@mui/material';
import { palette } from 'view/themes/palette';

export const FormWrapperForgotLink = styled(Link)({
  width: '100%',
  display: 'flex',
  alignItems: 'flex-start',
  margin: '0 0 24px 0',
  color: palette.primary.purple500,
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '21px',
  cursor: 'pointer',
  textDecoration: 'none',
}) as typeof Link;
